import InnerNavbar from '../../components/feature/InnerNavbar';
import InnerFooter from '../../components/feature/InnerFooter';
import LocationsHero from './components/LocationsHero';
import LocationsGrid from './components/LocationsGrid';
import LocationsFAQ from './components/LocationsFAQ';
import TrustBar from '../home/components/TrustBar';
import WhyChooseUs from '../home/components/WhyChooseUs';
import About from '../home/components/About';
import Process from '../home/components/Process';
import ServiceArea from '../home/components/ServiceArea';
import Testimonials from '../home/components/Testimonials';
import QuoteForm from '../home/components/QuoteForm';

export default function LocationsPage() {
  return (
    <div className="min-h-screen bg-white">
      <InnerNavbar activePage="locations" />

      {/* 2 — Hero */}
      <LocationsHero />

      {/* 3 — TrustBar */}
      <TrustBar />

      {/* 4 — Services (Location Regions Grid) */}
      <LocationsGrid />

      {/* 5 — WhyChooseUs */}
      <WhyChooseUs />

      {/* 6 — About */}
      <About />

      {/* 7 — Process */}
      <Process />

      {/* 8 — ServiceArea */}
      <ServiceArea />

      {/* 9 — Testimonials */}
      <Testimonials />

      {/* 10 — FAQ */}
      <LocationsFAQ />

      {/* 11 — QuoteForm */}
      <QuoteForm />

      <InnerFooter />

      {/* Sticky Mobile CTA */}
      <div className="fixed bottom-6 left-6 z-50 lg:hidden">
        <a
          href="tel:7606257767"
          className="flex items-center gap-3 bg-gradient-to-r from-amber-500 to-amber-600 text-white px-6 py-4 rounded-2xl shadow-2xl hover:shadow-amber-500/50 transition-all duration-300 hover:scale-105"
        >
          <div className="w-10 h-10 flex items-center justify-center bg-white/20 rounded-xl">
            <i className="ri-phone-fill text-xl"></i>
          </div>
          <div className="text-left">
            <div className="text-xs font-medium opacity-90 whitespace-nowrap">Call Now</div>
            <div className="text-sm font-bold whitespace-nowrap">(760) 625-7767</div>
          </div>
        </a>
      </div>

      {/* Floating Quote Button */}
      <div className="fixed bottom-6 right-6 z-50">
        <a
          href="#quote-form"
          className="flex items-center justify-center w-16 h-16 bg-slate-900 text-white rounded-full shadow-2xl hover:bg-amber-500 transition-all duration-300 hover:scale-110"
        >
          <i className="ri-file-list-3-line text-2xl"></i>
        </a>
      </div>
    </div>
  );
}
